<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="重置密码"
      center
      width="600px"
      :before-close="$onClose"
      destroy-on-close
      @close="close()"
    >
      <div>
        <div>
          <h4 class="title">密码</h4>
          <el-input
            v-model="passwd_old"
            placeholder="请输入"
            type="password"
          ></el-input>
        </div>
        <div>
          <h4 class="title">密码验证</h4>
          <el-input
            v-model="passwd_new"
            placeholder="请输入"
            type="password"
          ></el-input>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/strUtils";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";

export default {
  data() {
    return {
      changVisible: false,

      admin_id: "",
      passwd_old: "",
      passwd_new: "",
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
      this.passwd_old = "";
      this.passwd_new = "";
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;
      if (this.passwd_old !== this.passwd_new) {
        this.$message.error("密码验证不通过");
        return;
      }
      if (this.passwd_old.length > 20 || this.passwd_old.length < 6) {
        this.$message.error("密码长度必须在6到20位之间");
        return;
      }
      this.resetPasswd();
    },
    //页面初始化时加载的事件
    show(admin_id) {
      this.admin_id = admin_id;
      this.changVisible = true;
    },
    // 管理员重置密码
    resetPasswd() {
      this.$api
        .resetPasswd({
          token: localStorage.getItem("token"),
          admin_id: this.admin_id,
          passwd: this.passwd_new,
        })
        .then(({ data }) => {
          this.close();
        })
        .catch(({ error }) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/adminResetPwdDialog.vue